import { render, staticRenderFns } from "./DetailsGallery.vue?vue&type=template&id=5a7f57e4&scoped=true&"
import script from "./DetailsGallery.vue?vue&type=script&lang=js&"
export * from "./DetailsGallery.vue?vue&type=script&lang=js&"
import style0 from "./DetailsGallery.vue?vue&type=style&index=0&id=5a7f57e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7f57e4",
  null
  
)

export default component.exports